import type { TodoNavigationSummary } from '../../types/data';
import { getSupabase } from '../supabaseClient';

export interface TodoNavigationSummaryParams {
  calendarFrom: string;
  calendarTo: string;
  timezone?: string;
  now?: string;
}

export const todoNavigationSummaryRepo = {
  async getTodoNavigationSummary(params: TodoNavigationSummaryParams): Promise<TodoNavigationSummary> {
    const supabase = getSupabase();
    const { data, error } = await supabase.rpc('get_todo_navigation_summary', {
      p_calendar_from: params.calendarFrom,
      p_calendar_to: params.calendarTo,
      p_timezone: params.timezone ?? 'Asia/Tokyo',
      p_now: params.now ?? null,
    });

    if (error) throw error;
    return data as TodoNavigationSummary;
  },
};
